module.exports = __webpack_public_path__ + "ac8d0ecf930cf976b4fdeaaf365dd061.fbx";